export default __webpack_public_path__ + "static/media/LENS_CULINARIS_OGRE_complete_5.b32c8475.jpg";